import {
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
  CardContent,
} from '#app/components/ui/card.js'

export default function Summmary({ summary }: { summary: string }) {
  return (
    <Card className="h-full overflow-auto">
      <CardHeader>
        <CardTitle>Summary</CardTitle>
        <CardDescription></CardDescription>
      </CardHeader>
      <CardContent>
        <div className="whitespace-pre-wrap leading-7 [&:not(:first-child)]:mt-6">
          {summary}
        </div>
      </CardContent>
    </Card>
  )
}
